import HTML from "../images/html-5.svg";
import CSS from "../images/css3.svg";
import JS from "../images/javascript.svg";
import React from "../images/react.svg";
import Nodejs from "../images/node-js.svg";
import MongoDB from "../images/mongodb.svg";
import Redux from "../images/redux.svg";
import Xd from "../images/xd.svg";
import Wordpress from "../images/wordpress.svg";

export const services = [
  {
    id: 1,
    title: "HTML5",
    disc: "HTML5 is a markup language used for structuring and presenting content on the World Wide Web.",
    img: HTML,
  },
  {
    id: 2,
    title: "CSS3",
    disc: "CSS is the beauty of a website. I will provide good responsive websites using CSS (grid & flexbox).",
    img: CSS,
  },
  {
    id: 3,
    title: "Javascript",
    disc: "Java Script is a functionality of a website. i will provide you a Fully functional website using Javascript .",
    img: JS,
  },
  {
    id: 4,
    title: "React",
    disc: "React is an excellent tool with which to create interactive applications for mobile, web, and other platforms. React's popularity and usage are increasing day by day for good reason.",
    img: React,
  },
  {
    id: 5,
    title: "Node JS",
    disc: "Node.js has been regarded as a full-stack JavaScript for serving both the client and the server-side applications.",
    img: Nodejs,
  },
  {
    id: 6,
    title: "Mongo DB",
    disc: "MongoDB is more fast and scalable in comparison to the SQL server and MongoDB supports a big amount of data.",
    img: MongoDB,
  },
  {
    id: 7,
    title: "Redux",
    disc: "Redux is a state management tool for JavaScript applications. While it is frequently used with React, and it is compatible with many other framworks also.",
    img: Redux,
  },
  {
    id: 8,
    title: "XD",
    disc: "Adobe XD is a powerful and easy-to-use vector-based experience design platform that gives teams the tools they need to craft the world's best experiences collaboratively.",
    img: Xd,
  },
  {
    id: 9,
    title: "Wordpress",
    disc: "WordPress is open source software you can use to create a beautiful website, blog, or app. Beautiful designs, powerful features, and the freedom to build.",
    img: Wordpress,
  },
];
